import { useTranslation } from 'react-i18next'
import {
  formatPackagingItemAuditRunTimestamp,
  formatPackagingItemChangeHistoryTimestamp,
} from './formatPackagingItemAuditRunTimestamp'

type PackagingItemChangeHistoryTimestampCellProps = {
  timestamp: string | null | undefined
}

export function PackagingItemChangeHistoryTimestampCell({
  timestamp,
}: PackagingItemChangeHistoryTimestampCellProps) {
  const { t, i18n } = useTranslation(['packagingSuppliers', 'common'])

  if (timestamp == null || timestamp.trim() === '') {
    return (
      <span className='text-sm text-muted-foreground'>
        {t('common:notAvailable')}
      </span>
    )
  }

  const formatted = formatPackagingItemChangeHistoryTimestamp(
    timestamp,
    i18n.language
  )
  const title = formatPackagingItemAuditRunTimestamp(timestamp, i18n.language)

  return (
    <span
      className='block truncate text-sm text-muted-foreground'
      title={title}
    >
      {formatted}
    </span>
  )
}
